export default "__VITE_PUBLIC_ASSET__4ccbb2f5__"